// packages
import { makeStyles } from '@rneui/themed';

export default makeStyles(() => ({
  container: {
    width: '100%',
    maxWidth: 500
  }
}));
